import { render, staticRenderFns } from "./commDialog.vue?vue&type=template&id=da566938&scoped=true&"
import script from "./commDialog.vue?vue&type=script&lang=js&"
export * from "./commDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da566938",
  null
  
)

export default component.exports